<template>
    <div class="w-full group/video relative">
        <div class="relative aspect-video">
            <video
                ref="video"
                :controls="false"
                :poster="posterUrl"
                crossorigin="anonymous"
                class="w-full h-full relative rounded-xl cursor-pointer bg-natt"
                @click="playing = !playing"
            ></video>
            <button
                v-if="button && !playing"
                class="btn bg-fjell flex text-white shadow-lg items-center absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none"
            >
                <svg-icon name="play" class="w-6 h-6 mr-2" />
                {{ t('Spill video') }}
            </button>
        </div>
        <div
            class="flex items-center gap-4 absolute left-4 right-4 bottom-4 z-[2] transition-opacity opacity-0 group-hover/video:opacity-100"
        >
            <VideoScrubber
                v-if="showControls"
                v-model="currentTime"
                :max="duration"
                :secondary="endBuffer"
                class="w-full"
            >
                <template #tooltip="{ position, pendingValue }">
                    <small
                        class="absolute transform -translate-x-1/2 bg-svart rounded px-2 bottom-3 py-1 text-white pointer-events-none"
                        :style="{ left: position }"
                    >
                        {{ formatDuration(pendingValue) }}
                    </small>
                </template>
            </VideoScrubber>
            <button @click="toggle">
                <svg-icon name="fullskjerm" class="size-5 text-white" />
            </button>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { useMediaControls, useFullscreen } from '@vueuse/core';
import type { UseMediaTextTrackSource } from '@vueuse/core';
const img = useImage();
const { t } = useI18n();
const props = defineProps({
    poster: {
        type: String,
        required: true
    },
    src: {
        type: String || URL,
        required: true
    },
    button: {
        type: Boolean,
        required: false,
        default: true
    },
    showControls: {
        type: Boolean,
        required: false,
        default: true
    },
    tracks: {
        type: Array as () => UseMediaTextTrackSource[],
        required: false,
        default: () => []
    }
});
const video = ref<HTMLVideoElement>();
const { toggle } = useFullscreen(video);
const controls = useMediaControls(video, {
    src: {
        src: props.src
    },
    tracks: props.tracks
});
const { playing, buffered, currentTime, duration } = controls;

const posterUrl = computed(() => {
    return img(props.poster, { width: 600, format: 'webp' });
});
const endBuffer = computed(() =>
    buffered.value.length > 0 ? buffered.value[buffered.value.length - 1][1] : 0
);
const formatDuration = (seconds: number) => {
    return new Date(1000 * seconds).toISOString().slice(14, 19);
};
</script>
